import React  from 'react';

import "./BarcodeInfoModal.scss";



import { Trans, useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";


export function BarcodeInfoModal({ ...props }) {

  const [t] = useTranslation();

  const onConfirm = () => {
    props.onHide();
  }

  return <Modal {...props} centered dialogClassName="barcodeInfoModal">
    <Modal.Header closeButton />
    <Modal.Body>
      <div className="barcodeInfoModal-content">

        <span className="barcodeInfoModal-content-title1">{t("BarcodeInfoModalTitle1")}</span>

        <div className="barcodeInfoModal-content-imgContainer">
          <img className="barcodeInfoModal-content-imgContainer-img" src="/barcodeInfo.png" alt="image" />
        </div>

        <span className="barcodeInfoModal-content-text1">{t("BarcodeInfoModalSubtitle1")}</span>

        <span className="barcodeInfoModal-content-title2">{t("BarcodeInfoModalTitle2")}</span>
        <span className="barcodeInfoModal-content-text2"><Trans i18nKey="BarcodeInfoModalSubtitle2" components={[<a/>]} /></span>

        <Button className="button" onClick={()=> onConfirm()}>{t("BarcodeInfoModalConfirmBtn")}</Button>
      </div>
    </Modal.Body>
  </Modal>;
}